import { Box, Card, CardContent, IconButton, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, Tooltip } from "@mui/material"
import { formatBytes } from "../utils/ByteConverter"
import { useContext, useState } from "react";
import { AreaContext } from "../context/AreaContext";

export const BaseAllocation = () => {

  const [tab, setTab] = useState(0);

  const handleChange = (event, newTab) => {
    setTab(newTab);
  }

  const {area} = useContext(AreaContext);

  const baseAllocation = area.storagePacks.filter(sp => sp.type === "DEFAULT")[0];

  const renderAllocation = () => (
    <Card sx={{ color: "black" }}>
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>{baseAllocation.id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Size</TableCell>
              <TableCell>{formatBytes(baseAllocation.size)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );

  return (
    <Box
      sx={{
        width: "30%",
        border: "2px solid black",      // border around the whole structure
        borderRadius: 1,
        overflow: "hidden",
        margin: "10px"
      }}
    >
      <Tabs
        value={tab}
        onChange={handleChange}
        variant="fullWidth"
  sx={{
    "& .MuiTab-root": {
      backgroundColor: "white",
      color: "black",
    },
    "& .MuiTab-root.Mui-selected": {
      backgroundColor: "#A60F2D",
      color: "white",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  }}
      >
        <Tab label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  Basic Allocation Information
                </Box>  
        }     
        />
      </Tabs>

      {tab === 0 && baseAllocation !== undefined && renderAllocation()}
    </Box>
  );
};